<template>
  <div class="box8">
    <pageTitle 
      title="哪些人可以考" 
      titleColor="#332114"
    />
    <ul class="content">
      <li v-for="(item, index) in list">
        <div class="left">
          <img :src="item.url" alt="">
        </div>
        <div class="right">
          <div class="tips">{{ item.tips }}</div>
          <div class="info" v-html="item.info"></div>
        </div>
      </li>
    </ul>

  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      list:[
        {
          tips: '快速拿证者',
          info: `想要提升自我，解决职业瓶颈问题，想通过课程短时间内快速取得ACP（大数据）证书，为通关加码人员`,
          url: require('../../../assets/coursePage/acp/box8/pic-01.png')
        },
        {
          tips: '技术流',
          info: `想要快速全面了解云服务业务特性和价值的人员，如：IT、运维、管理、技术等，想通过课程解决实际工作应用问题`,
          url: require('../../../assets/coursePage/acp/box8/pic-02.png')
        },
        {
          tips: '兴趣观望者',
          info: `0基础观望者，刚接触、有兴趣使用或需要使用阿里云的各类人员，包括大数据产业中的架构、分析、开发等相关从业者`,
          url: require('../../../assets/coursePage/acp/box8/pic-03.png')
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.box8{
  padding: 80px 0;
  background-image: url(../../../assets/coursePage/acp/box8/bg.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
  .content{
    padding-top: 20px;
    width: 690px;
    margin: 0 auto;
    li{
      margin-top: 30px;
      height: 202px;
      background-color: #ffffff;
      box-shadow: 0px 10px 30px 0px 
        #ffe5cc;
      border-radius: 20px;
      border: solid 2px #ffe0bf;
      padding: 20px;
      box-sizing: border-box;
      display: flex;
      .left{
        width: 120px;
        min-width: 120px;
        height: 120px;
        margin-right: 30px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .right{
        .tips{
          font-family: SourceHanSansCN-Medium;
          font-size: 28px;
          line-height: 28px;
          color: #332114;
          font-weight: bold;
        }
        .info{
          margin-top: 13px;
          font-family: SourceHanSansCN-Normal;
          font-size: 24px;
          line-height: 36px;
          color: #666666;
        }
      }
    }
  }
}
</style>